var map = {
	"./icon-actuator-2.svg": "46f4",
	"./icon-add-circle-outline.svg": "a2b6",
	"./icon-add-outline.svg": "94b1",
	"./icon-add.svg": "605f",
	"./icon-alert-hight-full.svg": "0450",
	"./icon-alert-hight-outline.svg": "4a7c",
	"./icon-alert-medium-full.svg": "df0f",
	"./icon-alert-medium-outline.svg": "8c5c",
	"./icon-all-plants.svg": "15c1",
	"./icon-arrows-back.svg": "6b1a",
	"./icon-arrows-down.svg": "7526",
	"./icon-arrows-next.svg": "8cbd",
	"./icon-arrows-up.svg": "764e",
	"./icon-assistant.svg": "8049",
	"./icon-automation-2.svg": "1f93",
	"./icon-automation.svg": "33d3",
	"./icon-ban-light.svg": "cba1",
	"./icon-bathroom.svg": "3a90",
	"./icon-bedroom.svg": "2dc5",
	"./icon-blind.svg": "3343",
	"./icon-blueprint.svg": "50da",
	"./icon-book.svg": "a24e",
	"./icon-checkbox-disabled.svg": "7a74",
	"./icon-close.svg": "9f16",
	"./icon-colored-light.svg": "89d8",
	"./icon-command.svg": "df05",
	"./icon-confirm-full.svg": "754d",
	"./icon-confirm-outline.svg": "56b2",
	"./icon-connected-server.svg": "a17c",
	"./icon-corridor.svg": "b9ef",
	"./icon-datetime.svg": "1496",
	"./icon-delete.svg": "94ba",
	"./icon-desktop.svg": "983e",
	"./icon-device.svg": "03b8",
	"./icon-dimmer-dmx.svg": "7a49",
	"./icon-diningroom.svg": "501c",
	"./icon-done.svg": "1e96",
	"./icon-duplication-all.svg": "b32a",
	"./icon-duplication.svg": "3a03",
	"./icon-edit-page.svg": "d0d6",
	"./icon-edit.svg": "1eee",
	"./icon-electrical-cabinet.svg": "2aa1",
	"./icon-ellipsis-v.svg": "137d",
	"./icon-email.svg": "f1cb",
	"./icon-energy.svg": "b05d",
	"./icon-entrance.svg": "b000",
	"./icon-expand-menu.svg": "420d",
	"./icon-failed-full.svg": "a6b2",
	"./icon-failed-outline.svg": "78b2",
	"./icon-fancoil.svg": "7b42",
	"./icon-faq.svg": "3437",
	"./icon-favourite-outline.svg": "efba",
	"./icon-favourite.svg": "ef9e",
	"./icon-filter.svg": "0931",
	"./icon-filters.svg": "f5b0",
	"./icon-garage.svg": "e25a",
	"./icon-garden.svg": "18bc",
	"./icon-general-light.svg": "8bae",
	"./icon-general-view.svg": "1cb3",
	"./icon-grid.svg": "5084",
	"./icon-group-lights.svg": "c7c0",
	"./icon-kitchen.svg": "f795",
	"./icon-laundry.svg": "26cc",
	"./icon-less.svg": "1fe0",
	"./icon-light.svg": "2967",
	"./icon-list.svg": "9a3b",
	"./icon-livingroom.svg": "2d2a",
	"./icon-loading.svg": "e315",
	"./icon-lock.svg": "a1b1",
	"./icon-mail.svg": "aaa7",
	"./icon-mobile-device.svg": "fcc4",
	"./icon-music-player.svg": "2a2b",
	"./icon-mx-server.svg": "eba1",
	"./icon-network.svg": "e331",
	"./icon-no-view.svg": "c6d8",
	"./icon-notification.svg": "dce2",
	"./icon-office.svg": "790c",
	"./icon-outdoor.svg": "6f2c",
	"./icon-paperclip.svg": "fa60",
	"./icon-plan-duplicate.svg": "fffe",
	"./icon-plants.svg": "f643",
	"./icon-player.svg": "c733",
	"./icon-plus-outline.svg": "1212",
	"./icon-profile.svg": "4fab",
	"./icon-push-notification.svg": "6d4c",
	"./icon-refresh.svg": "1af7",
	"./icon-remove-hand-02.svg": "797b",
	"./icon-remove-outline.svg": "79ab",
	"./icon-reorder-drag-and-drop.svg": "fcb4",
	"./icon-room.svg": "a24d",
	"./icon-round-outline.svg": "5115",
	"./icon-round.svg": "0b54",
	"./icon-scan-qr-code-02.svg": "b205",
	"./icon-scene.svg": "c4c4",
	"./icon-search.svg": "6a1a",
	"./icon-security-2.svg": "2f55",
	"./icon-security.svg": "a13f",
	"./icon-server-mhs-1.svg": "63ec",
	"./icon-setting.svg": "e942",
	"./icon-shutter.svg": "1e5c",
	"./icon-socket.svg": "4e1f",
	"./icon-staff.svg": "8dec",
	"./icon-staircase.svg": "a1a2",
	"./icon-star.svg": "0c24",
	"./icon-start-plan.svg": "f9fc",
	"./icon-sync.svg": "4e9a",
	"./icon-thermo.svg": "dc59",
	"./icon-thermostat.svg": "a231",
	"./icon-toilets.svg": "01b6",
	"./icon-towel-rail.svg": "2a06",
	"./icon-user.svg": "a26a",
	"./icon-weather.svg": "e6c0",
	"./icon-wifi-01-1.svg": "c297",
	"./icon-wifi.svg": "f077",
	"./icon-wizard-assegna-attuatore.svg": "6a9d",
	"./icon-xmeter.svg": "0519",
	"./icon_command_day.svg": "78b0",
	"./icon_command_enter.svg": "afda",
	"./icon_command_exit.svg": "c34e",
	"./icon_command_night.svg": "0ec0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";